import { useQuery } from '@tanstack/react-query'

import { ApiPagedPayload } from '@/api/shared/types'

import { UsersService } from '..'
import { ContactsPayload } from '../lib/users.types'

export const CONTACTS_LIST_QUERY_KEY = 'contacts-list'

export const useUserContacts = ({
  projectId,
  pageSize,
  page
}: ApiPagedPayload<ContactsPayload>) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [CONTACTS_LIST_QUERY_KEY, projectId, pageSize, page],
    queryFn: () => UsersService.getContacts({ projectId, pageSize, page }),
    enabled: projectId.length > 0
  })

  return {
    data: data?.data || [],
    isLoading,
    isError,
    error,
    totalPages: data?.totalPages
  }
}
